module.exports = __webpack_public_path__ + "static/media/Details.de15ae9e.svg";